<template>
  <div id='rightImageBox' v-bind:class="{big: value.bigRightImage}">
        <dragableImage  id="rightImage" v-if="value.rightImage.imid != null" v-model="value.rightImage" :fullHeight="true" :rightOriented="true" isFirst="true" :disabled="disabled"></dragableImage>

        <svg width="0" height="0">
          <clipPath id="clipPolygonSmallRight" clipPathUnits="objectBoundingBox">
            <polygon points="1.000 0.000, 0.994 0.001, 0.984 0.002, 0.982 0.012, 0.977 0.030, 0.974 0.038, 0.970 0.037, 0.966 0.036, 0.950 0.053, 0.933 0.070, 0.920 0.073, 0.906 0.077, 0.902 0.083, 0.898 0.089, 0.892 0.088, 0.886 0.088, 0.883 0.093, 0.880 0.097, 0.885 0.098, 0.890 0.098, 0.865 0.110, 0.841 0.121, 0.845 0.123, 0.848 0.124, 0.836 0.138, 0.819 0.157, 0.810 0.167, 0.805 0.172, 0.811 0.173, 0.817 0.174, 0.812 0.180, 0.803 0.197, 0.801 0.207, 0.790 0.210, 0.780 0.212, 0.769 0.220, 0.758 0.229, 0.762 0.232, 0.767 0.234, 0.755 0.238, 0.743 0.242, 0.751 0.244, 0.754 0.246, 0.750 0.245, 0.752 0.253, 0.754 0.260, 0.742 0.269, 0.714 0.292, 0.697 0.305, 0.687 0.308, 0.677 0.311, 0.670 0.318, 0.663 0.329, 0.664 0.336, 0.665 0.340, 0.655 0.339, 0.644 0.338, 0.639 0.347, 0.633 0.356, 0.625 0.357, 0.617 0.358, 0.620 0.362, 0.624 0.366, 0.614 0.368, 0.604 0.371, 0.609 0.374, 0.615 0.377, 0.612 0.384, 0.602 0.400, 0.574 0.435, 0.552 0.460, 0.537 0.465, 0.521 0.470, 0.510 0.483, 0.501 0.498, 0.504 0.500, 0.483 0.522, 0.463 0.544, 0.456 0.545, 0.449 0.545, 0.457 0.547, 0.464 0.549, 0.451 0.550, 0.438 0.551, 0.444 0.554, 0.450 0.557, 0.443 0.555, 0.436 0.554, 0.434 0.555, 0.435 0.558, 0.438 0.560, 0.425 0.575, 0.411 0.590, 0.419 0.591, 0.426 0.592, 0.424 0.595, 0.421 0.598, 0.408 0.600, 0.394 0.603, 0.400 0.604, 0.405 0.605, 0.389 0.612, 0.373 0.619, 0.377 0.628, 0.381 0.637, 0.371 0.644, 0.351 0.656, 0.333 0.666, 0.326 0.677, 0.327 0.684, 0.329 0.688, 0.319 0.686, 0.309 0.685, 0.302 0.695, 0.294 0.705, 0.287 0.705, 0.280 0.705, 0.283 0.709, 0.287 0.713, 0.277 0.716, 0.267 0.719, 0.272 0.722, 0.278 0.725, 0.275 0.732, 0.266 0.748, 0.237 0.783, 0.215 0.808, 0.200 0.813, 0.184 0.818, 0.173 0.831, 0.165 0.846, 0.167 0.848, 0.147 0.869, 0.128 0.891, 0.119 0.893, 0.111 0.895, 0.120 0.895, 0.129 0.896, 0.117 0.897, 0.104 0.899, 0.102 0.902, 0.101 0.906, 0.088 0.922, 0.074 0.938, 0.082 0.939, 0.089 0.940, 0.087 0.943, 0.084 0.946, 0.071 0.948, 0.057 0.950, 0.063 0.952, 0.068 0.953, 0.052 0.960, 0.036 0.967, 0.041 0.975, 0.046 0.983, 0.037 0.989, 0.028 0.995, 0.015 0.994, 0.002 0.993, 0.004 0.996, 0.007 0.998, 0.000 1.000, 1.000 1.000, 1.000 0.000, 1.000 0.000">
            </polygon>
          </clipPath>
        </svg>
  </div>
</template>


<script>
import DragableImage from './draggableFlyerImage.vue'
export default {
  name: 'RightImageBox',
  data(){
    return {};
  },
  props: ['value', "rightOriented", "disabled"],
  components: {
    'dragableImage': DragableImage
  },
}

</script>

<style>

#rightImageBox{
    position: relative;
    width: 26mm;
    height:100%;
    display:inline-block;

    float:right;
    margin-left: 0px;
    shape-outside: polygon(80% 0%, 100% 0%, 100% 100%, -20% 100%);
    clip-path: url("#clipPolygonSmallRight");
}



#rightImageBox.big{
  width: 80mm;
}




</style>

